import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import News from "./News";
import Newsletter from "./newsletter/Newsletter";
import NavBar from "../NavBar";
import Footer from "../Footer";
import { getEvents } from "../../services/gallery";
import JornalNoticias from '../../images/news/jornalNegocios.jpg';
import Jogo from '../../images/news/jogo.jpg';
import TSF from '../../images/news/tsf.svg';
import Observador from '../../images/news/observador.jpg';

const relatedNews = [
  {
    title: "Porto students develop electric-powered unmanned boat.",
    source: "Observador",
    date: "June 2026",
    image: Observador,
    link: "https://observador.pt/2026/06/26/estudantes-do-porto-desenvolvem-barco-nao-tripulado-movido-a-energia-eletrica/",
  },
  {
    title: "FEUP students launch first solar boat with hull in natural fibers",
    source: "Jornal de Negócios",
    date: "June 2025",
    image: JornalNoticias,
    link: "https://www.jornaldenegocios.pt/sustentabilidade/ambiental/detalhe/estudantes-da-feup-lancam-primeiro-barco-solar-com-casco-em-fibras-naturais",
  },
  {
    title: "FEUP presents Atlântico, the first solar boat with natural fiber hull made by students",
    source: "O Jogo",
    date: "June 2025",
    image: Jogo,
    link: "https://www.ojogo.pt/modalidades/artigo/feup-apresenta-atlantico-o-primeiro-barco-solar-com-casco-de-fibras-naturais-feito-por-estudantes/17951174",
  },
  {
    title: "Atlântico ready to navigate solar-powered from FEUP to the world",
    source: "TSF",
    date: "June 2025",
    image: TSF,
    link: "https://noticias.up.pt/feup/tsf-atlantico-pronto-a-navegar-movido-a-energia-solar-da-feup-para-o-mundo/",
  },
];

function NewsPage() {
  const [events, setEvents] = useState([]);
  const [eventsLoading, setEventsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const hash = location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  }, [location]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (eventsLoading) {
        console.warn("Events timed out — check Firebase config and gallery collection");
        setEventsLoading(false);
      }
    }, 8000);

    const unsub = getEvents((fetchedEvents) => {
      clearTimeout(timeout);
      setEvents(fetchedEvents);
      setEventsLoading(false);
    });
    return () => {
      clearTimeout(timeout);
      unsub();
    };
  }, []);

  if (eventsLoading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />

      <div className="flex-grow pt-16">
        <section id="news">
          <News />
        </section>

        <section id="newsletter">
          <Newsletter />
        </section>

        <section id="related-news" className="bg-slate-950">
          <div className="max-w-7xl mx-auto px-4 py-20">
            <div className="flex justify-between items-center mb-8">
              <h2 className="font-custom md:text-7xl text-3xl font-bold text-white">Related News</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {relatedNews.map((news, idx) => (
                <a
                  key={idx}
                  href={news.link}
                  target="_blank"
                  className="group relative overflow-hidden rounded-2xl border border-white/10 hover:border-mainBlue transition-all duration-300 aspect-video"
                >
                  <img src={news.image} alt={news.title} className="absolute inset-0 w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/50 to-transparent" />
                  <div className="relative z-10 p-6 h-full flex flex-col justify-end">
                    <h3 className="text-white font-bold text-lg">{news.title}</h3>
                    <p className="text-gray-400 text-sm">{news.date}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default NewsPage;
